import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {Form, FormControl, FormGroup} from '@angular/forms';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MonthWiseCountModel} from '../../shared/dto/month-wise-count.model';
import {WorkFlowStageModel} from '../../shared/dto/work-flow-stage-model';
import {SearchRequestService} from '../../shared/service/search-request.service';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {Router} from '@angular/router';
import {SearchRequestDetailModel} from '../../shared/dto/search-request-detail.model';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import swal from 'sweetalert2';

@Component({
  selector: 'app-request-search-date-wise',
  templateUrl: './request-search-date-wise.component.html',
  styleUrls: ['./request-search-date-wise.component.scss']
})
export class RequestSearchDateWiseComponent implements OnInit, AfterViewInit {

  public dateTimeRange: Date[] = [];
  public requestForm: FormGroup;
  public dto: MonthWiseCountModel[] = [];
  public max = new Date();
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  displayedColumns: string[] = ['Year', 'Month', 'Count'];
  dataSource: MatTableDataSource<any>;
  public item: MonthWiseCountModel[] = [];
  public workflowList: WorkFlowStageModel[] = [];
  public totalCount: number;

  constructor(private searchRequestService: SearchRequestService,
              private tokenStorageService: TokenStorageService,
              private spinnerService: NgxUiLoaderService,
              private router: Router) {
  }

  ngOnInit() {
    this.requestForm = new FormGroup({
      refNo: new FormControl(null),
      cdcNo: new FormControl(null),
      cocNo: new FormControl(null),
      sidNo: new FormControl(null),
      dateTimeRange: new FormControl(null),
      status: new FormControl(null),
      biometricStatus: new FormControl(null),
      dataverification: new FormControl(null)
    });

    this.loadAllWorkflows();

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  loadAllWorkflows() {
    this.searchRequestService.getAllWorkflows().subscribe(
      (data: WorkFlowStageModel[]) => {
        this.workflowList = data;
      }
    );
  }

  onClickReset() {
    this.requestForm.reset({
      refNo: null,
      cdcNo: null,
      cocNo: null,
      dateTimeRange: [],
    });
  }

  onSubmitSearch(form: FormGroup) {
    const searchRequestDTOS = new SearchRequestDetailModel(form.value.refNo, form.value.cdcNo, form.value.cocNo, form.value.dateTimeRange, form.value.status, form.value.biometricStatus, form.value.dataverification, form.value.sidNo);
    this.loadSearchResultList(searchRequestDTOS);
  }

  loadSearchResultList(searchRequestDTO: SearchRequestDetailModel): void {
    this.spinnerService.start();
    this.searchRequestService.searchRequestCount(searchRequestDTO).subscribe(
      (data: MonthWiseCountModel[]) => {
        if (data.length > 0) {
          this.dto = data;
          this.calculateTotal();
          this.dataSource = new MatTableDataSource(this.dto);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;

        }

      },
      (error) => {
        this.spinnerService.stop();
        swal.fire('Sorry!', 'Something went wrong...!', 'error');
      },
      () => {
        this.spinnerService.stop();
        if (this.dto == null || this.dto.length === 0) {
          swal.fire('Sorry', 'No result found.', 'info');
        } else {
          this.searchRequestService.clearRequestCountSearchDetails();
          this.searchRequestService.setRequestCountSearchDetails(
            this.dto
          );

        }
      }
    );
  }


  calculateTotal() {
    this.totalCount = this.dto.slice().reduce((accum, curr) => accum + curr.count, 0);
    this.dto.push({year: null, month: 'Total', count: this.totalCount});
    console.log(this.dto);

  }

  exportPdf(){
    this.spinnerService.start();
    this.searchRequestService.exportPdf(this.dto).subscribe(
      (data:any) =>{
        console.log("This Data " + data);
        const file = new Blob([data], {type:'application/pdf'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL,"_blank");
      }, error => {
        this.spinnerService.stop();
        console.log(error);
      }
    );
    this.spinnerService.stop();
  }

  exportExcel() {
    this.spinnerService.start();
    this.searchRequestService.exportExcel(this.dto).subscribe(
      (data:any) =>{
        console.log("This Data " + data);
        const file = new Blob([data], {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL,"_blank");
      }, error => {
        this.spinnerService.stop();
        console.log(error);
      }
    );
    this.spinnerService.stop();
  }
}
